import { type WebsiteData } from '@/api/ai/website';
export const WebsiteInfo = ({
  websiteData
}: {
  websiteData: WebsiteData;
}) => {
  return <div className="flex flex-col gap-2xs" data-sentry-component="WebsiteInfo" data-sentry-source-file="WebsiteInfo.tsx">
      {/* 제목 */}
      <h3 className="w-full truncate text-body-lg-semibold text-default">
        {websiteData.title}
      </h3>

      {/* 설명 */}
      {websiteData.description && <p className="line-clamp-2 text-body-md-medium text-neutral">
          {websiteData.description}
        </p>}

      {/* 도메인 */}
      <div className="flex w-full items-center whitespace-nowrap text-body-sm-medium text-alternative">
        <span className="min-w-0 truncate">{websiteData.domain}</span>
      </div>

      {/* 작성자 및 게시일 (옵셔널) */}
      {(websiteData.author || websiteData.publishedAt) && <div className="flex items-center gap-3xs text-caption-md-medium text-alternative">
          {websiteData.author && <span>✍️ {websiteData.author}</span>}
          {websiteData.author && websiteData.publishedAt && <span>•</span>}
          {websiteData.publishedAt && <span>📅 {websiteData.publishedAt}</span>}
        </div>}
    </div>;
};